/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/*
// Author: Grin Zhou
*/

import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, HelpBlock, DropdownButton, MenuItem, Button } from 'react-bootstrap';
import ItemTitle from "../ItemTitle/index";
import BaseComponent from "../BaseComponent";

export default class Select extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      dropDownListShow: false
    };

    [
      'getValueText',
      'valueDidChange',
      'delAction',
      'handleShowHideMenu',
    ].forEach((fn) => this[fn] = this[fn].bind(this));

    this.setupData(props)
  }

  getValueText = (selected)=> {
    /*
    * return the text value by selected item id, to set the (react-bootstrap "DropdownButton") components required prop.
    */

    const { content } = this.props;
    let targetText = null;
    content.selectOptions && content.selectOptions.forEach((item) => {
      if (item.id === selected) {
        targetText = item.text;
      }
    });

    return targetText;
  };

  valueDidChange = (eventKey, event, eventText) => {
    /*
    * callback the onChange action.
    */

    event.preventDefault();
    event.stopPropagation && event.stopPropagation();
    event.stopImmediatePropagation && event.stopImmediatePropagation();

    const { content, onChangeAction } = this.props;
    onChangeAction && onChangeAction(content.questionRel, eventKey, event, eventText);

    return false;
  };

  delAction = (event) => {
    /*
    * callback the onClick action for the "Delete" button.
    * (the delete button will showing up in combined component)
    */

    event.preventDefault();
    event.stopPropagation && event.stopPropagation();
    event.stopImmediatePropagation && event.stopImmediatePropagation();

    const target = event.target;
    if ((target.className).indexOf('disabled') > -1) {
      return false;
    } else {
      const { onDelAction } = this.props;
      onDelAction && onDelAction(target);
    }

    return false;
  };

  handleShowHideMenu = ()=> {
    /*
    * handle drop down menu show or hide.
    */

    this.setState({
      dropDownListShow: !this.state.dropDownListShow
    });
  };

  setupData(props) {
    /*
    * setup component required props.
    */

    const {
      content
    } = props;

    this.titleObj = {
      questionMark: content.questionMark,
      question: {title: content.itemTitle.text, dataKey: content.itemTitle.dataKey},
      questionTip: content.questionTip,
      controlFor: (content.questionRel && content.questionRel.questionId) || '',
      // controlFor: content.dataKey,
      dropDownBtnId: (content.questionRel && content.questionRel.questionId) || 'basic-dropdown'
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setupData(nextProps)
  }

  render() {
    const {
      content,
      disabled,
      hasDelBtn,
      removeText,
      parentIndex
    } = this.props;

    const _SELECTED_ID = content.defaultValue || content.selectOptions[0].id;
    const _SELECTED_VALUE = this.getValueText(_SELECTED_ID);
    const isDisabled = disabled ? 'disabled' : false;
    const dropDownBtnId = (content.questionRel && content.questionRel.questionId) || 'basic-dropdown';

    return (
      <div className="clearfix">
          <div className="select">
            { content && content.itemTitle && <ItemTitle content={ this.titleObj } /> }

              <FormGroup
                validationState={ content.isError ? 'error' : null }
                className={ hasDelBtn ? 'has-delete-btn' : '' }
              >
                  <div className={`select-wrapper ${isDisabled}`}>
                    {this.state.dropDownListShow ?
                      <i aria-hidden={true} className="icon icon-chevron-up-small">{}</i>
                      :
                      <i aria-hidden={true} className="icon icon-chevron-down-small">{}</i>
                    }

                      <div className="select-object">
                          <DropdownButton
                            title={ _SELECTED_VALUE }
                            id={ dropDownBtnId }
                            onToggle={ this.handleShowHideMenu }
                            data-key={ content.dataKey }
                            disabled={ isDisabled }
                            // aria-describedby={`${dropDownBtnId}-err ${dropDownBtnId}-title`}
                            aria-describedby={`${dropDownBtnId}-err`}
                            aria-label={ content.itemTitle.text+' '+_SELECTED_VALUE }
                          >
                            {
                              content.selectOptions && content.selectOptions.map((item) => {
                                const activeLabel = content.defaultValue === item.id;

                                return (
                                  <MenuItem
                                    key={ item.id }
                                    eventKey={ item.id }
                                    active={ activeLabel }
                                    onSelect={ (eventKey, event) => this.valueDidChange(eventKey, event, item.text) }
                                    data-key={ item.dataKey || item.id }
                                    aria-label={ item.text }
                                  >
                                    { item.text }
                                  </MenuItem>
                                )
                              })
                            }
                          </DropdownButton>
                      </div>
                  </div>

                { content.validatedTips &&
                <HelpBlock id={`${dropDownBtnId}-err`}> { content.validatedTips } </HelpBlock>
                }

                {
                  hasDelBtn &&
                  <Button
                    bsStyle={'link'}
                    aria-label={removeText}
                    className="delete-btn"
                    onClick={ this.delAction }
                    data-index={ parentIndex }
                    data-key={ `${content.questionRel.questionIndicator}-removeText` }
                  >
                    { removeText }
                  </Button>
                }
              </FormGroup>
          </div>
      </div>
    )
  }
};

Select.propTypes = {
  content: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  defaultValue: PropTypes.string,
  onChangeAction: PropTypes.func,
  validationState: PropTypes.bool,
  hasDelBtn: PropTypes.bool,
  onDelAction: PropTypes.func,
  removeText: PropTypes.string,
  parentIndex: PropTypes.number
};

Select.defaultProps = {
  content: {},
  validationState: false,
  hasDelBtn: false
};


// WEBPACK FOOTER //
// ./src/shared/AOForm/components/Select/index.js